/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2023-04-06 11:31:59
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2024-04-28 16:51:41
 * FilePath     :\AV-COM-user-backend\src\utils\cookies.js
 * RevisionHistory:
 */
const cookies = {
    // 设置Cookie
    set: function (name, value, options) {
        let domain = window.location.hostname
            .replace("testwww.", "")
            .replace("www.", "");
        options = options || {};
        let expires = options.expires;
        if (typeof expires == "number" && expires) {
            let d = new Date();
            d.setTime(d.getTime() + expires * 24 * 60 * 60 * 1000);
            expires = options.expires = d;
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }
        value = encodeURIComponent(value);
        let updatedCookie = name + "=" + value;
        for (let propName in options) {
            updatedCookie += "; " + propName;
            let propValue = options[propName];
            if (propValue !== true) {
                updatedCookie += "=" + propValue;
            }
        }
        console.log("------------cookie-----------");
        console.log(`${updatedCookie}; domain=${domain}`);
        document.cookie = `${updatedCookie}; domain=${domain}`;
    },
    // 获取Cookie
    get: function (name) {
        let matches = document.cookie.match(
            new RegExp(
                "(?:^|; )" +
                    name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
                    "=([^;]*)"
            )
        );
        return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    //   // 删除Cookie
    //   remove: function (name) {
    //     this.set(name, "", { expires: -1 });

    //   },
    // 删除Cookie
    remove: function (name) {
        let domain = window.location.hostname
            .replace("testwww.", "")
            .replace("www.", "");
        // let path = "/";
        // let currentPath = window.location.pathname;
        // if (currentPath !== "/") {
        //     path = currentPath;
        // }
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
        // 删除格式为 .abc.com 的 Cookie
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`;
    },
};

export default cookies;
